

import Vue from 'vue'
import App from './App'
import router from './router'
import VCharts from 'v-charts'
import './assets/SetSize'


import { Button, Popup, Cell, DatetimePicker } from 'vant'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(Button)
.use(Popup)
.use(Cell)
.use(DatetimePicker)
Vue.use(VCharts)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.config.productionTip = false
const FastClick = require('fastclick')
FastClick.attach(document.body)
router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title
}
next()
})

console.log = function () {}
/* eslint-disable */
new Vue({
el: '#app',
router,
template: '<App/>',
components: {
App
}
})



// WEBPACK FOOTER //
// ./src/main.js